import React, { useEffect, useState, useRef } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useActions } from '../../hooks/useActions';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import logo from '../../img/gritr_logo.png';
import { validateLoginForm } from './Login.service';
import '../../css/Login.css';

const Login: React.FC = () => {
  const { loading, url, isAuthenticated } = useTypedSelector(
    (state) => state.auth
  );
  const { login } = useActions();

  const btn = useRef<HTMLButtonElement>(null);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const { email, password } = formData;
  const [requiredLogin, setRequiredLogin] = useState({
    email: { filled: false, message: '' },
    password: { filled: false, message: '' },
  });

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onClickLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    const data = validateLoginForm({
      old: requiredLogin,
      values: formData,
    });
    setRequiredLogin(data.state);
    if (data.preventChange) return;

    // login(email, password);
    login({ email, password });
  };

  useEffect(() => {
    const listener = (e: KeyboardEvent) => {
      if (e.code === 'Enter' || e.code === 'NumpadEnter') {
        if (btn.current) {
          btn.current.click();
        }
      }
    };

    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, []);

  //Redirect if logged in
  if (isAuthenticated || localStorage.token) {
    if (url) {
      return <Navigate to={url} />;
    }

    return <Navigate to='/dashboard/' />;
  }

  return (
    <div className='login-container'>
      <img src={logo} alt='Logo' className='login-logo' />
      <form className='login-box'>
        <div className='login-form-box'>
          <h2 className='login-form-header'>Sign in</h2>
          <input
            className={`login-input ${
              requiredLogin.email.filled ? 'login-request-input-error' : ''
            }`}
            type='email'
            placeholder='Email'
            name='email'
            autoComplete='off'
            onChange={onChange}
          />
          <p className='login-form-error'>{requiredLogin.email.message}</p>
          <input
            className={`login-input ${
              requiredLogin.password.filled ? 'login-request-input-error' : ''
            }`}
            type='password'
            placeholder='Password'
            name='password'
            autoComplete='off'
            onChange={onChange}
          />
          <p className='login-form-error'>{requiredLogin.password.message}</p>
          <Link className='login-forgot primary-link' to='/resetPassword/'>
            Forgot Password ?
          </Link>
          <button
            ref={btn}
            className='login-button'
            onClick={onClickLogin}
            disabled={loading}
          >
            Sign In
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
